const BORRADOR = '0'
const EN_REVISION = '1'
const APROBADO = '2'
const RECHAZADO = '3'
const DADO_DE_BAJA = '4'
const ANULADO = '5'

const __dictionary = {
  [BORRADOR]: { id: BORRADOR, nombre: 'BORRADOR', color: 'secondary' },
  [EN_REVISION]: { id: EN_REVISION, nombre: 'EN REVISIÓN', color: 'warning' },
  [APROBADO]: { id: APROBADO, nombre: 'APROBADO', color: 'info' },
  [RECHAZADO]: { id: RECHAZADO, nombre: 'RECHAZADO', color: 'danger' },
  [DADO_DE_BAJA]: { id: DADO_DE_BAJA, nombre: 'DADO DE BAJA', color: 'dark' },
  [ANULADO]: { id: ANULADO, nombre: 'ANULADO', color: 'muted' }
}

const __array = [
  __dictionary[BORRADOR],
  __dictionary[EN_REVISION],
  __dictionary[APROBADO],
  __dictionary[RECHAZADO],
  __dictionary[DADO_DE_BAJA],
  __dictionary[ANULADO]
]

export default Object.freeze({
  BORRADOR,
  EN_REVISION,
  APROBADO,
  RECHAZADO,
  DADO_DE_BAJA,
  ANULADO,
  __dictionary,
  __array
})
